// extracted by mini-css-extract-plugin
module.exports = {"sizeFix":"I5HND","collectionDescription":"lgIA3"};